import Skeleton from "react-loading-skeleton";
import CompetitionList from "../../../components/ActiveCompetitions/competitionList";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/a11y";
import "swiper/css/navigation";
import React from "react";
import { useCompetitionByType } from "../../../redux/features/categories/selectors";

interface SwiperWrapperProps {
  children: React.ReactNode;
}

const SwiperWrapper = ({ children }: SwiperWrapperProps) => (
  <Swiper
    modules={[A11y, Pagination, Navigation]}
    pagination={{ clickable: true }}
    navigation
    spaceBetween={10}
    className="xs:!pt-0 lg:!pt-[2rem] !pb-[2rem]"
    rewind={true}
    breakpoints={{
      1080: {
        slidesPerView: 3,
      },
      240: {
        slidesPerView: 1.1,
      },
    }}>
    {React.Children.map(children, (child, index) => (
      <SwiperSlide key={index} className="!h-auto">
        {child}
      </SwiperSlide>
    ))}
  </Swiper>
);

const Loader = () => (
  <Skeleton inline highlightColor="#fff" count={3} height={500} containerClassName={"grid grid-cols-3 gap-4"} />
);

const AllCompetitions = () => {
  const featuredCategory = useCompetitionByType("featured");
  return (
    <div className="carousel-container-with-top-navigation">
      <h5 className="text-left text-[#28282B] font-jost text-[16px] font-medium mb-[20px] leading-[22px]">
        Explore our competitions
      </h5>
      <CompetitionList category={featuredCategory} LoadingComponent={Loader} WrapperComponent={SwiperWrapper} />
    </div>
  );
};

export default AllCompetitions;
